export enum SportEventTypeContributionEnum {
  PLACED_BETS = 'placed_bets',
  SETTLED_BETS = 'settled_bets',
}
